<template>
    <div class="field" id="slottedfield" :style="!haveTopMargin ? 'margin-top: 0;' : ''">
        <div class="alignleft" v-if="!!leftSlotMethod && !!leftSlotText">
            <a id="slottedfield-leftslot-link" class="link" @click="leftSlotMethod">
                {{ leftSlotText }}
            </a>
        </div>
        <div class="alignright" v-if="!!rightSlotMethod && !!rightSlotInfoText && !!rightSlotLinkText">
            <p>
                {{rightSlotInfoText}}
                <a id="slottedfield-rightslot-link" class="link" @click="rightSlotMethod"
                   @keyup.enter.prevent="rightSlotMethod" tabindex="0"
                   :aria-label="rightSlotInfoText+' '+rightSlotLinkText">
                    {{rightSlotLinkText}}
                </a>
            </p>
        </div>
        <div style="clear: both;"></div>
    </div>
</template>

<script>
export default {
  props: {
    leftSlotMethod: {
      type: Function,
      default: undefined
    },
    leftSlotText: {
      type: String,
      default: ''
    },
    rightSlotMethod: {
      type: Function,
      default: undefined
    },
    rightSlotInfoText: {
      type: String,
      default: ''
    },
    rightSlotLinkText: {
      type: String,
      default: ''
    },
    haveTopMargin: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
    #slottedfield {
        margin-top: 20px;
    }

    #slottedfield .link {
        cursor: pointer;
    }

    .alignleft {
        float: left;
    }

    .alignright {
        float: right;
    }

    @media (max-width: 665px) {
        .alignright {
            float: none;
        }
    }
</style>
